export default __webpack_public_path__ + "static/media/Arjun.f15a3731.jpeg";